import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Modal, Box, Fade, Backdrop } from "@mui/material";
import CloseImg from "Images/profile/close_icon.svg";
import RoundedGainfulButton from "../../common/RoundedGainfulButton";
import styles from "./styles.module.scss";
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: "#FAF9F5",
    border: "none",
    borderRadius: "50px",
    boxShadow: 24,
    padding: "44px",
    maxWidth: "650px",
    outline: "none",
};
const WarningModal = ({ open, handleClose, onClick }) => (_jsx(Modal, { open: open, onClose: handleClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", closeAfterTransition: true, slots: { backdrop: Backdrop }, children: _jsx(Fade, { in: open, children: _jsx(Box, { sx: style, component: "div", children: _jsxs("div", { className: styles.wrapper, children: [_jsx("button", { className: styles.close, type: "button", onClick: handleClose, children: _jsx("img", { src: CloseImg, alt: "" }) }), _jsx("div", { className: styles.title, children: "We're here for you" }), _jsx("div", { className: styles.text, children: "Based on your inputs, your results are showing under the recommended values. Please reach out to your Registered Dietitian for further assistance" }), _jsx(RoundedGainfulButton, { label: "Connect with RD", onClick: onClick })] }) }) }) }));
export default WarningModal;
